import React from 'react';
import { store } from '../../store'
import Tab from 'react-bootstrap/Tab'
import Nav from 'react-bootstrap/Nav'
import { 
    customerNameById,
    formatKennitala,
    singleSignerComplete,
    allSignersComplete,
    copyToClipboard,
    getContractOverviewPDF,
    getDescriptiveContractName,
    allInsuranceTakersHaveId,
    allCustomersRisOnly,
    allInsuranceTakersHaveIdOrUseExisting,
    isSignerOnlyGuardian as isSignerOnlyGuardian,
    excludeGuardiansFromSigners,
    allInsuranceTakersHaveTin,
    insuranceTakerHasTin,
    Spinner,
    insuranceTakerWillUseExistingId
} from '../../utils'
import { SvgDownloadIcon, SvgCheckIcon, SvgCloseIcon, SvgAddIcon, SvgInfoIcon } from '../svg';
import { openModal } from '../../api/gui/actions'
import connectWithStore from '../../utils/store'

import Alert from 'react-bootstrap/Alert'

import Accordion from 'react-bootstrap/Accordion'
import Card from 'react-bootstrap/Card'
import Button from 'react-bootstrap/Button'
import { SigningModal } from '../modals'
import { fetchTilbod, generateContractFiles, sendContract, extendTilbod, changeStatus,fetchAdditionalAnswers } from '../../api/offers/actions';
import { exportQuestionnaireAnswers } from '../../api/questionnaires/actions';

import moment from 'moment'
import { fetchIdentification } from '../../api/id/actions';
import { setKey } from '../../api/insurance-takers/actions';
import IdSelection from '../id-selection';
import TinUpdater from '../tin-updater';
import { Link } from 'react-router-dom'



class Sign extends React.PureComponent {

    constructor(props) {
        super(props)

        this.state = {
            copied: false,
            signerPhotoIdSelection: {},
            aqModalTitle: "",
            aqModalSigningUrl: "",
            refreshAdditionalAnswers: 0,
            aqSigning: ''
        }

        this.timer = null
        this.aqTimer = null;

        this.submitData = this.submitData.bind(this)
        this.clippy = this.clippy.bind(this)
        this.extendContract = this.extendContract.bind(this)
        this.getOverviewPDF = this.getOverviewPDF.bind(this)
        this.changeStatus = this.changeStatus.bind(this)
        this.signAdditionalQuestions = this.signAdditionalQuestions.bind(this)
        this.consolelog = this.consolelog.bind(this)
        this.cusstomerHasId = this.cusstomerHasId.bind(this)
    }

    consolelog(v) {
        console.log(v);
        return true;
    }

    onSelectionUpdate(signer) {
        let state = { ...this.state.signerPhotoIdSelection }
        state[signer] = 'Skilríki hafa verið móttekin'
        this.setState({ signerPhotoIdSelection: state })
    }

    localAllSignersComplete(tilbod) {
        return allSignersComplete(tilbod) && 
            (!this.props.tilbod.jsondata.subContracts || 
                (this.props.tilbod.jsondata.subContracts  && 
                    this.props.additionalQuestionsAnswers && Object.values(this.props.additionalQuestionsAnswers).every(item => item.signed || item.disabled)
                )
            );
    }

    componentDidMount() {
        this.props.dispatch(fetchTilbod(this.props.match.params.token))
        if (this.timer === null) {
            this.timer = setInterval(() => this.props.dispatch(fetchTilbod(this.props.match.params.token, true)), 5000)
        }
    }

    componentWillUnmount() {
        const signers = this.getSigners()
        if (this.timer != null && signers.length > 0) {
            clearInterval(this.timer);
            this.timer = null;
        }
    }

    componentDidUpdate(prevProps, prevState) {
        if (this.timer === null && !(this.localAllSignersComplete(this.props.tilbod) || this.props.tilbod.error)) {
            this.timer = setInterval(() => this.props.dispatch(fetchTilbod(this.props.match.params.token, true)), 5000)
        }

        const signers = this.getSigners()
        signers.map(signer => {
            if (!this.props.identification.customers[signer] || (this.props.identification.customers[signer] && !this.props.identification.customers[signer].isFetching && !this.props.identification.customers[signer].done && signers.length > 0)) {
                this.props.dispatch(fetchIdentification(signer))
                if (this.props.insuranceTakers.insuranceTakers[signer] === undefined) {
                    this.props.dispatch(setKey({ key: 'inital', value: null }, signer));
                }
            }
        })
        if ((!this.props.tilbod.isFetching &&
            this.props.tilbod.jsondata.subContracts &&
            !prevProps.tilbod.jsondata.subContracts)
            ||
            (this.state.refreshAdditionalAnswers !== prevState.refreshAdditionalAnswers)) {
            for (let subContract of this.props.tilbod.jsondata.subContracts) {
                this.props.dispatch(fetchAdditionalAnswers(subContract.token));
            }
        }
		if (this.state.aqSigning.length > 0 && this.props.signingModals && 
			('SigningModal-additional' in this.props.signingModals) && 
			!this.props.signingModals['SigningModal-additional']) {
            const aqSigning = this.state.aqSigning;
            setTimeout(() => this.props.dispatch(fetchAdditionalAnswers(aqSigning)),2000);
			this.setState({aqSigning : ''});
		}        
    }

    submitData() {
        Promise.resolve(this.props.dispatch(sendContract(this.props.match.params.token)))
            .then(d => {
                this.props.dispatch(fetchTilbod(this.props.match.params.token, true))
            })
    }

    onNavLinkClick(e) {
        var tab = $(e.target).parents('.nav-item').prev('.nav-item');

        $('.tabs .nav-item').removeClass('no-border');
        tab.addClass('no-border');
    }

    noSigningUrl(contractFile) {
        return `/api/v1/contractfile/${contractFile.id}/pdf/?index=${contractFile.pdf_index ? contractFile.pdf_index : 0}${contractFile.template ? `&template=${contractFile.template}` : ''}${this.props.tilbod.paper_signing ? '&no_signature=True' : ''}`
    }

    noSigningUrlMarkDownloaded(contractFile) {
        return `/api/v1/contractfile/${contractFile.id}/pdf/?index=${contractFile.pdf_index ? contractFile.pdf_index : 0}${contractFile.template ? `&template=${contractFile.template}` : ''}${this.props.tilbod.paper_signing ? '&no_signature=True' : ''}&mark_downloaded=True`
    }

    getSignedDocumentUrl(contractFile) {
        return `/api/v1/contractfile/${contractFile.id}/dokobit/`
    }

    clippy() {
        copyToClipboard(this.props.tilbod.customer_signing_url)
        this.setState({ copied: true })
    }

    extendContract(token) {
        Promise.resolve(this.props.dispatch(extendTilbod(token)))
            .then(response =>
                this.props.dispatch(fetchTilbod(token, true))
            )
    }

    changeStatus(contractFile, token, status, subContractId) {
        let confirmed = false
        let component = this
        if (status === false) {
            if (window.confirm(`Ertu viss um að þú viljir taka þessa samningsgerð úr tilboði fyrir ${contractFile.customer_id}?`)) {
                confirmed = true
            }
        } else {
            if (window.confirm(`Ertu viss um að þú viljir setja þessa samningsgerð aftur inn í tilboð fyrir ${contractFile.customer_id}?`)) {
                confirmed = true
            }
        }
        if (confirmed) {
            Promise.resolve(this.props.dispatch(changeStatus(token, contractFile.contract_type, contractFile.customer_id, status, subContractId)))
                .then(response => {

                    this.props.dispatch(fetchTilbod(token, subContractId === null))
                    if ((component.timer === null || component.timer === undefined) && !(this.localAllSignersComplete(this.props.tilbod) || this.props.tilbod.error)) {
                        component.timer = setInterval(() => component.props.dispatch(fetchTilbod(token, true)), 5000)
                    }
                    if (subContractId !== null) {
                        this.setState({refreshAdditionalAnswers : this.state.refreshAdditionalAnswers+1});
                    }
                })
        }
    }

    getOverviewPDF() {

        $('#samantekt-download-button').show();

        getContractOverviewPDF({ token: this.props.tilbod.token }, '#samantekt-download-button')

    }

    getSigners() {
        const { tilbod } = this.props
        let signers = []
        if (!((this.props.tilbod.isFetching && this.props.tilbod.contract_files && this.props.tilbod.contract_files.length === 0) || (!this.props.tilbod.contract_files))) {
            signers = [... new Set(tilbod.contract_files.map(c => {
                if (c.signing_needed || (tilbod.paper_signing && c.signer_id)) {
                    return c.signer_id
                }
            }).filter(f => f !== undefined))]
        } else {
            signers = []
        }
        return signers
    }

    additionalQuestionsHaveAnswer(token,signer) {
        // if we additionalQuestionsAnswers it will always contain at least
        // one key, namely "signed"
        return this.props.additionalQuestionsAnswers && 
            this.props.additionalQuestionsAnswers[token] && 
            this.props.additionalQuestionsAnswers[token][signer]
    }

    additionalQuestionsAreSigned(token,signer) {
        // if we additionalQuestionsAnswers it will always contain at least
        // one key, namely "signed"
        return this.props.additionalQuestionsAnswers && 
            this.props.additionalQuestionsAnswers[token] && 
            this.props.additionalQuestionsAnswers[token].signed
    }

    signAdditionalQuestions(token) {
        // guard against double entries
        if (this.state.aqSigning.length > 0) {
            return;
        }
        this.setState({aqSigning : token});
        Promise.resolve(this.props.dispatch(exportQuestionnaireAnswers(token,{},true)))
        .then(response => {
            const contract_file = response.contract_files[0];
            this.setState({
                aqModalTitle: contract_file.description,
                aqModalSigningUrl: contract_file.signing_url,
            });
            this.props.dispatch(openModal("SigningModal-additional"));
        })
    }

    cusstomerHasId(identification,customerId,insuranceTakers) {
        return identification && 
        identification.customers[customerId] && 
        !identification.customers[customerId].isFetching && 
        identification.customers[customerId]["Customer"]["Identification"] &&
        identification.customers[customerId].done &&
        insuranceTakerWillUseExistingId(insuranceTakers,customerId)
    }

    render() {
        const { tilbod, identification } = this.props

        if (tilbod.error) {
            clearInterval(this.timer)
            this.timer = null
            return (
                <div className="row justify-content-center xs-pt-10">
                    <div className="col-12 col-sm-10 col-md-8">
                        <div className="row justify-content-center xs-pt-10 step">
                            <Alert variant="warning" className="col-12 xs-mt-50">
                                <Alert.Heading>Villa</Alert.Heading>
                                {tilbod.errorMessage}
                            </Alert>
                        </div>
                    </div>
                </div>
            )
        }


        if ((this.props.tilbod.isFetching && this.props.tilbod.contract_files && this.props.tilbod.contract_files.length === 0) || (!this.props.tilbod.contract_files)) {
            return (<></>)
        } else {
            if (!this.props.tilbod.isGenerating && !this.props.tilbod.isFetching && this.props.tilbod.contract_files && this.props.tilbod.contract_files.length === 0) {
                this.props.dispatch(generateContractFiles(this.props.match.params.token))
            }
        }

        if (this.props.tilbod.isGenerating) {
            return (
                <div className="row justify-content-center xs-pt-10">
                    <div className="col-12 col-sm-10 col-md-8">
                        <div className="row justify-content-center xs-pt-10 step">
                            <Alert variant="success" className="col-12 xs-mt-50 text-center">
                                <Alert.Heading>Augnablik</Alert.Heading>
                                Við erum að útbúa skjöl til undirritunar
                            </Alert>
                        </div>
                    </div>
                </div>
            )
        }

        let jsondata = tilbod.jsondata
        let peopleByKennitala = jsondata.peopleByKennitala


        const signers = this.getSigners()

        let contract_files = {}
        signers.map(signer_id => {
            let cf = tilbod.contract_files.filter(f => f.signer_id === signer_id).map(f => ({...f}) )
            contract_files[signer_id] = cf;
            contract_files[signer_id].sort(function (f1, f2) {
                if (f1.contract_type == '') {
                    return Number.MAX_SAFE_INTEGER
                }
                if (f2.contract_type == '') {
                    return -Number.MAX_SAFE_INTEGER
                }
                let type_cmp = f1.contract_type.localeCompare(f2.contract_type)
                if (type_cmp == 0) {
                    return (f1.pdf_index != null ? f1.pdf_index : Number.MAX_SAFE_INTEGER ) - (f2.pdf_index != null ? f2.pdf_index : Number.MAX_SAFE_INTEGER );
                } else {
                    return type_cmp;
                }
            });
            let contract_types = [...new Set(contract_files[signer_id].map((cf) => cf.contract_type))];
            contract_types = contract_types.filter(ct => ['RISLEB', 'LEB', 'REN'].indexOf(ct) != -1);
            const allAdditionalQuestionsSigned = this.props.additionalQuestionsAnswers && Object.values(this.props.additionalQuestionsAnswers).every(item => item.signed); 
            if (!allAdditionalQuestionsSigned &&  contract_types.length > 0 &&
                jsondata.subContracts && 
                jsondata.subContracts.length > 0) {
                // add addtionalQeustions links for unsigned additional questions
                for (let subContract of jsondata.subContracts) {
                    // skip if it is not for the current signer
                    if (subContract.customer_id != signer_id) {
                        continue;
                    }
                    // skip if we are already signed
                    if (this.additionalQuestionsAreSigned(subContract.token,signer_id)) {
                        continue;
                    }
                    // get index of first file of contract_type
                    let cf_idx = 0;
                    for (var i = 0; i < contract_files[signer_id].length; i++) {
                        if (contract_files[signer_id][i].contract_type ==  subContract.contract_type) {
                            cf_idx = i + 1;
                            break;
                        }
                    }
                    // if we alread have additional qeustions pdf in the 
                    // cf set we skip 
                    if ((cf_idx+1 < contract_files[signer_id].length) &&
                        contract_files[signer_id][cf_idx+1].ref_additional_questions_contract_id) {
                        continue;
                    }

                    const addtionalQuestionsEntry = {...contract_files[signer_id][cf_idx-1]};
                    addtionalQuestionsEntry.id = subContract.id 
                    addtionalQuestionsEntry.description = "Aukaspurningapakki";
                    addtionalQuestionsEntry.token = subContract.token;
                    addtionalQuestionsEntry.signingUrl = "/fill/" + subContract.token;
                    addtionalQuestionsEntry.signing_needed = true;
                    addtionalQuestionsEntry.status = "to_be_filled";
                    addtionalQuestionsEntry.active = !subContract.disabled
                    contract_files[signer_id].splice(cf_idx+1,0,addtionalQuestionsEntry);
                }
            }
        });

        if (this.localAllSignersComplete(tilbod) || tilbod.error) {
            clearInterval(this.timer)
            this.timer = null
        }

        return (
            <>
                <div className="row justify-content-center xs-pt-10">
                    <div className="col-12 col-sm-10 col-md-8">
                        <div className="row justify-content-center xs-pt-10 step">
                            <Tab.Container id="base-info-collection-tabs" defaultActiveKey={signers[0]} >
                                <div className="tabs-container">
                                    <Nav variant="tabs" className="tabs w-100">
                                        {signers.map((customerId, idx) =>
                                            <Nav.Item key={customerId}>
                                                <Nav.Link eventKey={customerId} onClick={this.onNavLinkClick.bind(this)}>
                                                    {customerNameById(customerId, { peopleByKennitala })}<span>({formatKennitala(customerId)})</span>
                                                </Nav.Link>
                                                {singleSignerComplete(customerId, tilbod) &&
                                                    <span className="check-icon small blue"><SvgCheckIcon /></span>
                                                }
                                            </Nav.Item>
                                        )}
                                    </Nav>
                                </div>
                                <Tab.Content className="w-100">
                                    <p className="content-title">{this.props.tilbod.paper_signing ? "Undirritun" : "Rafræn undirritun"}</p>
                                    {signers.map((customerId, idx) =>
                                        <Tab.Pane key={customerId} eventKey={customerId}>

                                            {this.state.signerPhotoIdSelection[customerId] &&
                                                <div className="alert alert-info mb-5">{this.state.signerPhotoIdSelection[customerId]}</div>
                                            }
                                            {/* { this.consolelog(["a",customerId,!this.props.tilbod.questionnaire]) &&
                                              this.consolelog(["b",customerId,!isSignerOnlyGuardian(tilbod.jsondata.infoCollection, tilbod.jsondata.offerQueryParameters, customerId)]) &&
                                              this.consolelog(["d",customerId,!tilbod.contract_change]) &&
                                              this.consolelog(["e",customerId,!tilbod.contract_change]) &&
                                              this.consolelog(["f",customerId,!tilbod.sent]) &&
                                              this.consolelog(["g",customerId,!allInsuranceTakersHaveId(tilbod.jsondata.insuranceTakers, signers)]) &&
                                              this.consolelog(["h",customerId,!!tilbod.jsondata.infoCollection]) &&
                                              this.consolelog(["i",customerId,!!tilbod.jsondata.insuranceTakers]) &&
                                              this.consolelog(["j",customerId,!this.cusstomerHasId(identification,customerId)]) && */
                                              !this.props.tilbod.questionnaire &&
                                              !isSignerOnlyGuardian(tilbod.jsondata.infoCollection, tilbod.jsondata.offerQueryParameters, customerId) &&
                                              !tilbod.contract_change && !tilbod.sent && !allInsuranceTakersHaveId(tilbod.jsondata.insuranceTakers, signers) && tilbod.jsondata.infoCollection && 
                                              tilbod.jsondata.insuranceTakers && !this.cusstomerHasId(identification,customerId,tilbod.insuranceTakers) &&

                                                <IdSelection dispatch={this.props.dispatch}
                                                    customerId={customerId}
                                                    identification={identification}
                                                    tilbod={tilbod}
                                                    infoCollection={tilbod.jsondata.infoCollection}
                                                    offerQueryParameters={tilbod.jsondata.offerQueryParameters}
                                                    newInsuranceTakers={this.props.insuranceTakers}
                                                    insuranceTakers={tilbod.jsondata.insuranceTakers}
                                                    match={this.props.match}
                                                    store={this.props.store}
                                                    signers={signers}
                                                    peopleByKennitala={peopleByKennitala}
                                                    onSignerUpdate={this.onSelectionUpdate.bind(this)}
                                                />
                                            }

                                            {  !this.props.tilbod.questionnaire && !insuranceTakerHasTin(tilbod.jsondata.insuranceTakers, customerId) && 
                                                <div className="alert alert-warning">
                                                    Ekki er hægt að senda inn umsókn fyrr en búið er að skrá SSN/TIN fyrir tryggingataka þar sem hann er með sérstaka tengingu við Bandaríkin
                                                    <TinUpdater identificationState={identification} contractId={this.props.match.params.token} insuranceTakerId={customerId} dispatch={this.props.dispatch} />
                                                </div>
                                            }

                                            <Accordion defaultActiveKey="0">
                                                {contract_files[customerId].map((contractFile) =>
                                                    <Card key={contractFile.id}>
                                                        <Card.Header className={`${!contractFile.active ? 'inactive' : ''}`}>
                                                            <Accordion.Toggle eventKey="0" as={Button} variant="link" className="toggle-button limited">
                                                                {this.props.tilbod.paper_signing ?
                                                                    <>{(contractFile.status === 'contract_downloaded') &&
                                                                        <span className="check">
                                                                            <span className="check check-icon big green">
                                                                                <SvgCheckIcon />
                                                                            </span>
                                                                        </span>
                                                                    }</>
                                                                    :
                                                                    <>{(!contractFile.signing_needed || contractFile.signing_needed && contractFile.status === 'contract_signed' || contractFile.signing_needed && contractFile.status === 'contract_delivered') &&
                                                                        <span className="check">
                                                                            <span className="check check-icon big green">
                                                                                <SvgCheckIcon />
                                                                            </span>
                                                                        </span>
                                                                    }</>
                                                                }
                                                                { this.props.tilbod.questionnaire ? 
                                                                <div> {contractFile.description} </div>
                                                                :
                                                                <div>
                                                                    {contractFile.description}{contractFile.template !== 'afthokkun' && <>: {getDescriptiveContractName(contractFile.contract_type)}</>}
                                                                </div>
                                                                }
                                                                {contractFile.multi &&
                                                                    <div className="small">Athugið að fleiri en einn aðili þarf að undirrita þetta skjal til að hægt sé að senda inn gögn.</div>
                                                                }

                                                                <div className="actions">
                                                                    { contractFile.active && !this.props.tilbod.questionnaire && contractFile.status != 'to_be_filled' &&
                                                                        <a className="btn btn-outline-primary" onClick={() => this.props.dispatch(openModal(`SigningReadModal-${contractFile.id}`))}>Lesa</a>
                                                                    }
                                                                    {contractFile.signing_needed && contractFile.status === 'contract_uploaded' && contractFile.active &&
                                                                        <a className="btn btn-primary" onClick={() => this.props.dispatch(openModal(`SigningModal-${contractFile.id}`))}>Undirrita</a>
                                                                    }
                                                                    {contractFile.signing_needed && (contractFile.status === 'contract_signed' || contractFile.status === 'contract_delivered') && contractFile.active &&
                                                                        <>
                                                                            {contractFile.file_url !== "" ?
                                                                                <a href={this.getSignedDocumentUrl(contractFile)} download={`${contractFile.description}.pdf`} target="_blank" className="btn btn-primary"><SvgDownloadIcon /> Undirritað skjal</a>
                                                                                :
                                                                                <a className="btn btn-primary disabled" aria-disabled="true"><SvgDownloadIcon /> Undirritað skjal</a>
                                                                            }
                                                                        </>
                                                                    }
                                                                    { contractFile.active && !this.props.tilbod.questionnaire && contractFile.status == 'to_be_filled' && <>
                                                                        {!this.additionalQuestionsHaveAnswer(contractFile.token,customerId)
                                                                        ?
                                                                        <Link to={
                                                                            {pathname: contractFile.signingUrl,
                                                                             state: {
                                                                                from: this.props.location.pathname,
                                                                                onReturn: () => setTimeout(this.props.dispatch(fetchAdditionalAnswers(this.props.match.params.token)),200)
                                                                            }}} className="btn btn-primary">Svara spurningum</Link>
                                                                        :<>
                                                                        <Link to={{pathname: contractFile.signingUrl,
                                                                             state: {
                                                                                from: this.props.location.pathname,
                                                                                onReturn: () => setTimeout(this.props.dispatch(fetchAdditionalAnswers(this.props.match.params.token)),200)
                                                                            }}}  className="btn btn-outline-primary">Skoða svör</Link>
                                                                        <span style={{marginLeft:"10px", marginRight:"0"}}>
                                                                            <a className={`btn btn-primary`} 
                                                                               onClick={() => this.signAdditionalQuestions(contractFile.token)} >
                                                                                Undirrita {this.state.aqSigning.length > 0 && <Spinner />}
                                                                            </a>
                                                                        </span>
                                                                        </>
                                                                        }
                                                                    </>
                                                                    }
                                                                    {!contractFile.signing_needed && !tilbod.paper_signing && contractFile.active && contractFile.status != 'to_be_filled' &&
                                                                        <a href={this.noSigningUrl(contractFile)} download={`${contractFile.customer_id} ${contractFile.description}.pdf`} target="_blank" className="btn btn-primary"><SvgDownloadIcon /> Sækja skjal</a>
                                                                    }
                                                                    {tilbod.paper_signing && contractFile.active &&
                                                                        <a href={this.noSigningUrlMarkDownloaded(contractFile)} download={`${contractFile.customer_id} ${contractFile.description}.pdf`} target="_blank" className="btn btn-primary"><SvgDownloadIcon /> Sækja skjal</a>
                                                                    }
                                                                    {contractFile.status != 'to_be_filled' && !this.props.signingOnly && contractFile.contract_type !== '' && contractFile.active && !tilbod.sent && contractFile.ax_id === null &&
                                                                        <a onClick={() => this.changeStatus(contractFile, this.props.tilbod.token, false, null)} className="btn btn-danger" title={`Hætta við ${contractFile.contract_type}`}><SvgCloseIcon /></a>
                                                                    }
                                                                    {contractFile.status != 'to_be_filled' && !this.props.signingOnly && contractFile.contract_type !== '' && !contractFile.active &&
                                                                        <a onClick={() => this.changeStatus(contractFile, this.props.tilbod.token, true, null)} className="btn btn-success" title={`Virkja aftur ${contractFile.contract_type}`}><SvgAddIcon /></a>
                                                                    } 
                                                                    {
                                                                    //NOTE: SPECIAL CASE FOR "AUKASPURNINGAR" ACTIVATE/DISABLE     
                                                                     contractFile.status == 'to_be_filled' && !this.props.signingOnly && contractFile.contract_type !== '' && contractFile.active && !tilbod.sent && contractFile.ax_id === null &&
                                                                        <a onClick={() => this.changeStatus(contractFile, this.props.tilbod.token, false, contractFile.id)} className="btn btn-danger" title={`Hætta við Aukaspurningar`}><SvgCloseIcon /></a>
                                                                    }
                                                                    {
                                                                    //NOTE: SPECIAL CASE FOR "AUKASPURNINGAR" ACTIVATE/DISABLE     
                                                                     contractFile.status == 'to_be_filled' && !this.props.signingOnly && contractFile.contract_type !== '' && !contractFile.active && !tilbod.sent && contractFile.ax_id === null &&
                                                                        <a onClick={() => this.changeStatus(contractFile, this.props.tilbod.token, true, contractFile.id)} className="btn btn-success" title={`Virkja aftur Aukaspurningar`}><SvgAddIcon /></a>
                                                                    }                                                                    
                                                                </div>
                                                                <SigningModal title={contractFile.description} id={"SigningReadModal-" + contractFile.id} signingUrl={this.noSigningUrl(contractFile)} />
                                                                <SigningModal title={contractFile.description} id={"SigningModal-" + contractFile.id} signingUrl={contractFile.signing_url} />
                                                                {
                                                                this.props.additionalQuestionsAnswers?
                                                                    <SigningModal title={this.state.aqModalTitle} id={"SigningModal-additional"} signingUrl={this.state.aqModalSigningUrl} />
                                                                : <></>
                                                                }
                                                            </Accordion.Toggle>
                                                        </Card.Header>
                                                    </Card>

                                                )}
                                            </Accordion>

                                        </Tab.Pane>
                                    )}
                                </Tab.Content>
                            </Tab.Container>


                        </div>
                    </div>
                </div>
                {/* {allInsuranceTakersHaveTin(tilbod.jsondata.insuranceTakers, excludeGuardiansFromSigners(tilbod.signer_ids, tilbod.jsondata.infoCollection, tilbod.jsondata.offerQueryParameters))} */}
                <div className="container xs-pt-10 xs-pb-50">
                    <div className="row">
                        <div className="col-12 text-center button-container">
                            {(this.localAllSignersComplete(tilbod) || tilbod.paper_signing) &&
                                // <button onClick={() => this.submitData(CORRECT_STEP_ORDER.length)} className="next-btn btn btn-primary xs-m-10" disabled={this.state.disabled}>Senda gögn {isFetching && <Spinner />}</button>
                                <>
                                    {tilbod.sent &&
                                        <>
                                            <Alert variant="success" className="text-center ml-auto mr-auto col-5 xs-pt-50"><Alert.Heading>Umsókn hefur verið móttekin</Alert.Heading></Alert>
                                            {tilbod.paper_signing &&
                                                <Alert variant="warning" className="xs-mt-50">
                                                    Þú valdir að undirrita á pappír. Undirrituðum umsóknargögnum þarf að skila til Allianz á Íslandi til að klára umsóknarferlið.
                                                </Alert>
                                            }
                                        </>
                                    }
                                    { !this.props.tilbod.questionnaire && !tilbod.sent && this.localAllSignersComplete(tilbod) && 
                                     (allInsuranceTakersHaveTin(tilbod.jsondata.insuranceTakers, excludeGuardiansFromSigners(tilbod.signer_ids, tilbod.jsondata.infoCollection, tilbod.jsondata.offerQueryParameters))) && 
                                     (allInsuranceTakersHaveIdOrUseExisting(tilbod.jsondata.insuranceTakers, excludeGuardiansFromSigners(tilbod.signer_ids, tilbod.jsondata.infoCollection, tilbod.jsondata.offerQueryParameters)) 
                                        || 
                                         allCustomersRisOnly({ offerQueryParameters: { ...tilbod.jsondata.offerQueryParameters } })) &&
                                        ( window.offer_send_disabled
                                        ?
                                        <div className="alert alert-warning xs-m-10">
                                            <span className="xs-ml-10">Lokað fyrir innsendingu vegna kerfisuppfærslu</span>
                                        </div>
                                        :
                                        <button onClick={() => this.submitData()} className="btn btn-primary xs-m-10">
                                            {tilbod.isSending &&
                                                <i className="fa fa-spin fa-sync-alt xs-mr-10" />
                                            }
                                            Senda gögn
                                        </button>
                                        )
                                    }
                                    {tilbod.sendError && tilbod.sendErrorList &&
                                        <Alert variant="danger" className="col-12 xs-mt-50">
                                            <Alert.Heading>Villa kom upp við innsendingu gagna</Alert.Heading>
                                            {tilbod.sendErrorList.map((error, idx) =>
                                                <React.Fragment key={`send-error-${idx}`}>
                                                    <hr />
                                                    <p>
                                                        {error}
                                                    </p>
                                                </React.Fragment>
                                            )}
                                        </Alert>
                                    }
                                </>
                            }
                            { !tilbod.contract_files.map(f => f.template).includes('vidbot_7') && !tilbod.contract_files.map(f => f.template).includes('vidbot_11') && tilbod && !tilbod.questionnaire &&
                                <button className="btn btn-warning" onClick={() => this.getOverviewPDF()} >
                                    <SvgDownloadIcon />
                                    <span className="xs-ml-10">Sækja samantekt</span>
                                    <i style={{ display: 'none' }} id={`samantekt-download-button`} className="fa fa-spin fa-sync-alt xs-ml-10" />
                                </button>
                            }
                        </div>
                    </div>
                </div>
                {!this.props.signingOnly &&
                    <div className="container xs-pt-10 xs-pb-50 justify-content-center">
                        <div className="row justify-content-center text-center">
                            <h4>Undirritunarslóð fyrir viðskiptavin
                                {this.props.tilbod.created_at &&
                                    <>
                                        {this.props.tilbod.signing_extension ?
                                            <> (opin til {moment.utc(this.props.tilbod.created_at).add(this.props.tilbod.signing_extension, 'days').format("D.M.YYYY")})</>
                                            :
                                            <> (opin til {moment.utc(this.props.tilbod.created_at).add(10, 'days').format("D.M.YYYY")})</>
                                        }
                                    </>
                                }</h4>
                            <p className="linkbox col-12 justify-content-center">{this.props.tilbod.customer_signing_url}</p>
                            <button className="btn btn-primary" onClick={this.clippy} >{this.state.copied && <SvgCheckIcon />} Afrita</button>
                            {!this.props.tilbod.signing_extension &&
                                <button className="btn btn-primary xs-ml-15" onClick={() => this.extendContract(this.props.tilbod.token)}>Framlengja til {moment.utc(this.props.tilbod.created_at).add(30, 'days').format("D.M.YYYY")}</button>
                            }
                        </div>
                    </div>
                }
            </>
        )
    }
}

Sign.defaultProps = {
}

function mapStateToProps(state) {

    var f = {
        tilbod: {},
        identification: {},
        insuranceTakers: {},
        questionnaires: {},
        signingModals: {},
        additionalQuestionsAnswers: {}

    }
    f.tilbod = (state.tilbod === undefined) ? {} : state.tilbod
    f.identification = (state.identification === undefined) ? {} : state.identification
    f.insuranceTakers = (state.insuranceTakers === undefined) ? {} : state.insuranceTakers
    f.signingModals = (state.gui && state.gui.signingModals) ? state.gui.signingModals : {};
    f.additionalQuestionsAnswers = (state.tilbod && state.tilbod.additionalQuestionsAnswers) ? state.tilbod.additionalQuestionsAnswers : {};
    return f;
}

export default connectWithStore(store, Sign, mapStateToProps);
